<script>
    import marked from 'marked';
    import moment from 'moment';

    export let timestamp;
    export let author;
    export let question;
    export let answer = null;

    $: date = moment(timestamp).format('D MMMM YYYY');
    $: name = author || 'Anonymous';

    $: renderedAnswer = answer ? marked(answer) : null;
</script>

<style lang="scss">
    .flex {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
    }

    .answer {
        margin: 1rem;
        padding-left: 1rem;
        border-left: dashed 1px $divider;
    }

    h4 {
        padding-top: 0.5rem;
    }
</style>

<article class="question">
    <div class="flex">
        <h3>
            {name} asked
        </h3>
        <div class="subtle">
            {date}
        </div>
    </div>

    <p>
        {question}
    </p>

    {#if renderedAnswer}
        <div class="answer">
            <h4>Nan Dake answered</h4>
            {@html renderedAnswer}
        </div>
    {/if}

</article>
<hr>
